import validations from "../ja/validations";
import front_end from "../front_end/jp";
import configs from "../ja/configs";

import { localize } from "vee-validate";
localize("ja");

const lang = {
  common: {
    default_title: "サエダオリジナル年賀状サービス",
    admin_header_title: "サエダオリジナル年賀状サービス 管理",
    admin_header_logout: "ログアウト",
    perpage: "表示件数",
    base_table: {
      loading_label: "Loading....",
      message_no_data: "該当するクーポンデータはございません",
    },
    alert: {
      header_confirm: "確認",
      header_alert: "", // TODO translate to ja
      btn_ok: "OK",
      btn_confirm: "はい",
      btn_no: "いいえ",
      btn_cancel: "キャンセル",
      btn_close: "閉じる",
    },
  },

  b005: {
    login_label_email: "ログインID",
    login_placeholder_email: "例）xxx@xxxxx.co.jp",
    login_label_password: "パスワード",
    forgot_link_password: "パスワード再設定",
    login_button_submit: "ログイン",
    message: {
      message_error_none: "{msg} を入力してください",
      message_error_digit: "{msg} の長さに誤りがあります",
      message_error_attribute: "{msg} は英数字記号の組合せで入力してください",
      auth_error: "ログインIDまたはパスワードが正しくありません",
    },
  },

  b010: {
    login_label_email: "ログインID",
    login_placeholder_email: "例）xxx@xxxxx.co.jp",
    login_lable_codeshop: "店舗コード",
    login_placeholder_codeshop: "例）123",
    submit_btn: "送信する",
    message: {
      message_error_none: "{msg}を入力してください",
      message_error_digit: "{msg}の長さに誤りがあります",
      message_error_attribute_email: "ログインIDを正しく入力してください",
      message_error_attribute_code: "店舗コードは半角数字で入力してください",
    },
  },
  b015: {
    message:
      "URLの有効期限が切れました。<br/> パスワード再設定リンクより再度お手続きください",
    btn: "ログイン画面へ",
  },
  b020: {
    login_id: "ログインID",
    login_id_placeholder: "例）xxx@xxxxx.co.jp",
    password_new: "新しいパスワード",
    password_new_cf: "新しいパスワード（確認)",
    btn_update: "変更する",
    errors: {
      require: " {msg} を入力してください",
      digit: " {msg} の長さに誤りがあります",
      value: " err {msg} は英数字記号の組合せで入力してください",
      combin: " パスワードは英数字記号の組合せで入力してください",
      not_same:
        " 新しいパスワードと新しいパスワード（確認）は同じ値で入力してください",
    },
    content_alert_success: "content_alert_success",
  },
  b040: {
    title_screen: "出荷済みデータ取込み",
    detail_title: "ＣＳＶファイルをアップロード",
    pl_choose_file: "ファイルを選択してください。",
    pl_select_file: "ファイルを選択してください",
    select_file: "ファイルを選択",
    register: "登録",
    select_file_incorrect: "選択したファイルに誤りがあります",
    fomat_file_incorrect: "ファイルフォーマットに誤りがあります",
  },
  b030: {
    title_screen: "注文詳細",
    btn_pause: "休止",
    btn_un_pause: "休止解除",
    btn_cancel: "キャンセル",
    btn_edit: "修正",
    btn_back: "戻る",
    detail_area_title: "注文内容",
    order_no: "オーダー番号",
    order_date: "注文日",
    store_code: "店舗ID",
    order_type_number: "注文タイプ番号",
    number_of_prints: "印刷数",
    payment: "決済",
    purchase_price: "購入金額",
    status: "状態",
    last_status: "前回状態",
    shipping_no: "発送番号",
    orderer_name: "注文者名",
    orderer_name_kata: "注文者名（カナ)",
    company_name: "会社名",
    department_name: "部署名",
    email: "Eメールアドレス",
    tel: "TEL",
    street_address: "住所",
    prefectures: "都道府県",
    city: "市区町村",
    jp_postal_mark: "〒",
    comment: "コメント",
  },
  b045: {
    title_screen: "クーポン一覧",
    search_placeholder: "検索",
    search_button_label: "検索",
    btn_create_coupon: "クーポン作成",
    btn_export_coupon: "クーポンデータ出力",
    message_no_data: "該当する  {msg}  はございません",
    headers: {
      couponCode: "クーポンコード",
      startUsingDate: "startUsingDate",
      endUsingDate: "利用期限",
      templateCategory: "templateCategory",
      templateType: "templateType",
      discountCombination: "早割併用",
      discountMethod: "割引方法",
      discountContent: "割引内容",
      numberOfDiscount: "利用回数",
      remarks: "備考",
      detail: "詳細",
    },
    alert: {
      more_than_one: "選択明細のクーポンデータを出力しますか？",
      nothing_selected:
        "全てのクーポンデータを出力しますか？ 　ダウンロード完了に時間がかかる場合がございます。",
    },
  },
  b050: {
    title_screen: "クーポン詳細",
    btn_edit_label: "修正",
    btn_back_label: "戻る",
    coupon_code: "クーポンコード",
    use_period: "利用期限",
    combination_promo_early: "早割併用",
    combination_promo_early_label: "早割との併用不可",
    discount_method: "割引方法",
    discount_method_amount: "金額",
    discount_method_percent: "割引率",
    discount_value: "割引内容",
    discount_unit_yen: "円",
    discount_unit_percent: "%",
    discount_note:
      "※写真タイプは基本料金、印刷タイプは印刷料金が割引の対象となります。",
    remarks: "備考",
    remarks_placeholder: "○○イベント用",
    times_use: "利用回数 ",
    times_use_value: "回",
  },
  b055: {
    title_screen: "クーポン {msg}",
    mode_create: "作成",
    mode_edit: "修正",
    code: "クーポンコード",
    use_date: "利用期限",
    early_discount: "早割併用",
    discount_method: "割引方法",
    discount_content: "割引内容",
    remarks: "備考",
  },
  b060: {
    title_screen: "割引一覧",
    search_placeholder: "検索",
    search_button_label: "検索",
    btn_create_discount: "割引作成",
    btn_export_discount: "割引データ出力",
    headers: {
      discountName: "割引名",
      startApplicationDate: "適用開始日",
      endApplicationDate: "適用終了日",
      templateCategory: "カテゴリ",
      templateType: "タイプ",
      discountMethod: "割引方法",
      discountContent: "割引内容",
      remarks: "備考",
      detail: "詳細",
    },
    alert: {
      more_than_one: "選択明細の割引データを出力しますか？",
      nothing_selected: "全ての割引データを出力しますか？",
    },
  },
  b065: {
    title_screen: "割引詳細 ",
    btn_edit: "修正",
    btn_back: "戻る",
    detail_title: "割引情報",
    discount_name: "割引名",
    day_start: "適用開始日",
    day_end: "適用終了日",
    category: "カテゴリ",
    type: "タイプ",
    discount_method: "割引方法",
    discount_method_amount: "金額",
    discount_method_percent: "割引率",
    discount_content: "割引内容",
    discount_unit: "割引単位",
    discount_unit_noti:
      "写真タイプは基本料金、印刷タイプは印刷料金が割引の対象となります。",
    remarks: "備考",
  },
  b070: {
    title_screen: "割引 {msg}",
    title_msg_create: "作成",
    title_msg_update: "更新",
    btn_edit: "修正",
    btn_back: "戻る",
    detail_title: "割引情報",
    detail_noti: "割引情報を入力してください",
    early_bird: "早割30",
    discount_name: "割引名",
    discount_value: "割引内容",
    day_start: "適用開始日",
    day_end: "適用終了日",
    category: "カテゴリ",
    type: "タイプ",
    discount_method: "割引方法",
    discount_method_amount: "金額",
    discount_method_percent: "割引率",
    discount_content: "割引内容",
    discount_unit: "割引単位",
    discount_unit_noti:
      "写真タイプは基本料金、印刷タイプは印刷料金が割引の対象となります。",
    remarks: "備考",
    messsage_require: "{msg} を入力してください",
    messsage_error_length: "{msg}  の長さに誤りがあります",
    messsage_error_atribute: "{msg} QA: B070 message errror thuoc tinh",
    messsage_error_notnumberhalfsize: "{msg} は半角数字で入力してください",
    message_error_start_great_then_end: "適用日の範囲指定に誤りがあります",
    message_error_discount_value_yen:
      "割引内容は1以上、9999以内で入力してください",
    message_error_discount_value_percent:
      "割引内容は1以上、100以内で入力してください",
  },
  b075: {
    title_screen: "テンプレート一覧",
    btn_all: "すべて",
    btn_search: "検索",
    btn_create: "作成",
    btn_detail: "詳細",
    message_no_data: "該当するクーポンデータはございません",
    search_placeholder: "検索",
    options: [
      {
        value: 1,
        content: "すべて",
      },
      {
        value: 2,
        content: "写真",
      },
      {
        value: 3,
        content: "印刷",
      },
      {
        value: 4,
        content: "セルフ",
      },
      {
        value: 5,
        content: "ハガキ",
      },
    ],
    header_table: {
      type_number: "タイプ番号",
      type: "タイプ",
      postcard_type: "ハガキ種類",
      start_date: "利用開始日",
      end_date: "利用終了日",
      status: "状態",
      store: "店舗",
    },
  },
  b080: {
    title_screen: "テンプレート情報",
    label: {
      image: "イメージ",
      type: "タイプ",
      template_no: "テンプレート番号",
      category: "カテゴリ",
      type_number: "タイプ番号",
      postcard_value: "ハガキ種類",
      postcard_type: "ハガキタイプ",
      start_date: "利用開始日",
      end_date: "利用終了日",
      store: "店舗",
      status: "状態",
    },
    message: {
      please_enter: "テンプレート情報を入力してください。",
      error_space_begin: "{msg}の先頭または末尾にスペースは指定できません",
      error_require: "{msg}を入力してください",
      error_date: "利用期間の範囲指定に誤りがあります",
      error_length: "{msg}の長さに誤りがあります",
    },
    btn: {
      create: "作成",
      update: "更新",
      back: "戻る",
      upload: "アップロード",
    },
    store_options: [
      {
        value: 1,
        label: "指定なし",
      },
      {
        value: 2,
        label: "指定",
      },
    ],
    status_options: [
      {
        value: 1,
        label: "公開",
      },
      {
        value: 2,
        label: "非公開",
      },
    ],
    category_options: [
      {
        label: "喪中・寒中",
        value: 1,
      },
      {
        label: "年賀",
        value: 2,
      },
      {
        label: "暑中・残暑",
        value: 3,
      },
      {
        label: "通年",
        value: 4,
      },
    ],
    type_options: [
      {
        label: "写真",
        value: 1,
      },
      {
        label: "印刷",
        value: 2,
      },
      {
        label: "セルフテンプレート",
        value: 3,
      },
    ],
    postcard_option: [
      [
        {
          label: "写真タイプ1",
          value: 1,
        },
        {
          label: "写真タイプ2",
          value: 2,
        },
        {
          label: "写真タイプ3",
          value: 3,
        },
        {
          label: "写真タイプ4",
          value: 4,
        },
        {
          label: "写真タイプ5",
          value: 5,
        },
        {
          label: "写真タイプ6",
          value: 6,
        },
        {
          label: "写真タイプ全・半",
          value: 7,
        },
        {
          label: "カープ",
          value: 8,
        },
        {
          label: "サンフレッチェ広島",
          value: 9,
        },
      ],
      [
        {
          label: "印刷",
          value: 1,
        },
        {
          label: "カープ",
          value: 2,
        },
        {
          label: "サンフレッチェ広島",
          value: 3,
        },
        {
          label: "広島LOVE",
          value: 4,
        },
      ],
    ],
  },
  b120: {
    title_header: "定型メッセージ一覧",
    btn_create: "作成",
    search_placeholder: "検索",
    search_button_label: "検索",
    message_no_data: "該当するクーポンデータはございません",
    categorys: [
      {
        label: "カテゴリ",
        value: "category",
      },
      {
        label: "喪中・寒中",
        value: "mourning_cold",
      },
      {
        label: "年賀",
        value: "new_year_card",
      },
      {
        label: "暑中・残暑",
        value: "summer_heat",
      },
      {
        label: "通年",
        value: "all_year_round",
      },
    ],
    types: [
      {
        label: "タイプ",
        value: "type",
      },
      {
        label: "一般",
        value: "general",
      },
      {
        label: "誕生",
        value: "birth",
      },
      {
        label: "結婚",
        value: "marriage",
      },
      {
        label: "転居",
        value: "relocation",
      },
      {
        label: "その他",
        value: "other",
      },
    ],
    header_table: {
      message_no: "メッセージ名号",
      category: "カテゴリ",
      type: "タイプ",
      message: "メッセージ",
      day_start_use: "利用開始日",
      day_end_use: "利用終了日",
      status: "状態",
      detail: "詳細",
    },
  },
  b110: {
    title_screen: "スタンプ情報",
    message: "スタンプ情報を入力してください。",
    label: {
      image: "イメージ",
      stamp_number: "スタンプ番号",
      category: "カテゴリ",
      type: "タイプ",
      start_date: "利用開始日",
      end_date: "利用終了日",
      status: "状態",
    },
    btn: {
      upload: "アップロード",
      back: "戻る",
      edit: "修正",
      create: "作成",
      update: "更新",
    },
    status_options: [
      {
        value: 1,
        label: "公開",
      },
      {
        value: 2,
        label: "非公開",
      },
    ],
  },
  b090: {
    title_screen: "不達メール一覧",
    search_placeholder: "検索",
    search_button_label: "検索",
    message_no_data: "該当するクーポンデータはございません",
    date_send: "メール送信日時",
    mail_address: "メールアドレス",
    content_email: "内容",
    type_email: "種別",
  },
  b095: {
    title_screen: "不達メール一覧",
    search_placeholder: "検索",
    button_read: "読込",
    button_delete: "削除",
    button_clear: "クリア",
    button_export_data: "印刷データ出力",
    button_export_order: "送り状・注文票出力",
    table: {
      order_no: "オーダー番号",
      status: "状態",
      store_name: "店名",
      date: "注文日",
      type_no: "タイプ番号",
      type_postcard: "ハガキ種類",
      number_of_pages: "枚数",
      bring_in: "持込",
      remarks: "備考",
      detail: "詳細",
    },
    message_no_data: "該当する注文データはございません",
    date_send: "メール送信日時",
    mail_address: "メールアドレス",
    content_email: "内容",
    type_email: "種別",
  },
  b100: {
    title_screen: "パスワード変更",
    btn_edit_label: "変更",
    note: "新しいパスワードを入力してください。",
    new_password: "新しいパスワード",
    confirm_password: "新しいパスワード（確認用）",
    note_new_password:
      "8～２０文字の半角の英数字または記号で入力してください。</br>" +
      "英字、数字または記号の2種類を含めてください。",
    note_confirm_password: "確認のため同じパスワードを入力してください。",
  },
  b125_130: {
    title_screen: "定型メッセージ詳細",
    title_create_edit: "定型メッセージ｛作成・修正｝",
    btn_edit: "修正",
    btn_create_edit: "｛作成・更新｝",
    btn_back: "戻る",
    detail_title: "定型メッセージ情報",
    mes_number: "メッセージ番号",
    message: "メッセージ",
    day_start: "利用開始日",
    day_end: "利用終了日",
    status: "状態",
    public: "公開",
    private: "非公開",
    category: "カテゴリ",
    type: "タイプ",
  },
  b025: {
    title_header: "画面タイトル",
    search_button_label: "検索",
    export_printdata_label: "印刷データ個別出力",
    export_order_label: "送り状・注文票出力",
    search_placeholder: "検索",
    headers: {
      order_no: "オーダー番号",
      status: "状態",
      shop_name: "店名",
      order_date: "注文日",
      type_number: "タイプ番号",
      type_postcard: "ハガキ種類",
      number_of_sheets: "枚数",
      bring_in: "持込",
      note: "備考",
      detail: "詳細",
    },
    alert: {
      selected_more: "一度に出力される件数は20件までです。",
      selected_confirm: "選択明細の印刷データを出力しますか？",
      cf_export_slip_order: "選択明細の送り状、注文票のデータを出力しますか？",
    },
  },
  b135: {
    title_screen: "郵便番号データ取込み",
    detail_title: "ＣＳＶファイルをアップロード",
    message_choose_file: "ファイルを選択してください。",
    message_select_file: "ファイルを選択してください",
    btn_select_file: "ファイルを選択",
    btn_register: "登録",
    select_file_incorrect: "選択したファイルに誤りがあります",
    fomat_file_incorrect: "ファイルフォーマットに誤りがあります",
  },
  validations,
  front_end,
  configs,
};

export default lang;
